import { Link, styled, css } from '@mui/material';

export const StyledLink = styled(Link)(
  ({ theme }) => css`
    color: ${theme.palette.common.white};
    text-decoration: underline;
    font-weight: bold;
  `,
);
